import type { AbschnittCElection } from "@/lib/abschnittc/AbschnittCElection";
import type {
	AbschnittCElectionResult,
	AbschnittCElectionResultComplete
} from "@/lib/abschnittc/AbschnittCElectionResult";
import type { AbschnittCElectionEvaluator } from "@/lib/abschnittc/AbschnittCElectionEvaluator";
import { AbschnittCElectionEvaluatorRun } from "@/lib/abschnittc/impl/AbschnittCElectionEvaluatorRun";
import { AbschnittCElectionResultSheetRenderer } from "@/lib/abschnittc/impl/AbschnittCElectionResultSheetRenderer";
import type { PdfDocumentManager } from "@/lib/pdflib2/PdfDocumentManager";
import type { TextProvider } from "@/lib/TextProvider";

export interface AbschnittCElectionEvaluatorImplOptions {
	pdfDocumentManager: PdfDocumentManager;
	textProvider: TextProvider;
	gitRevision: string;
	gitAuthor: string;
}

export class AbschnittCElectionEvaluatorImpl implements AbschnittCElectionEvaluator {

	constructor(private options: AbschnittCElectionEvaluatorImplOptions) {
	}

	evaluateElection(election: AbschnittCElection): AbschnittCElectionResult {
		const run = new AbschnittCElectionEvaluatorRun(election);
		return run.getResult();
	}

	async gerResultSheet(election: AbschnittCElection): Promise<ArrayBuffer> {

		const evaluatorRun = new AbschnittCElectionEvaluatorRun(election);
		const result = evaluatorRun.getResult();

		if (result.type !== "complete")
			throw new Error("Cannot generate result sheet for incomplete election result");

		const resultSheetGenerator = new AbschnittCElectionResultSheetRenderer({
			election: election,
			result: result,
			textProvider: this.options.textProvider,
			gitAuthor: this.options.gitAuthor,
			gitRevision: this.options.gitRevision,
			pdfDocumentManager: this.options.pdfDocumentManager
		});

		return await resultSheetGenerator.generate();
	}
}
